<script lang="ts">
    import {getInjector} from 'src/core';
    import type {DefinedAction} from 'shared/defined-actions';
    import KpButton from '../../ui-widgets/button/KpButton.svelte';
    import {DefinedActionPerformer} from '../../defined-actions/defined-action-performer';
    import type {ComponentSize, ButtonStyle} from '../../ui-widgets/types';
    import {createEventDispatcher} from 'svelte';

    export let action: DefinedAction;
    export let buttonStyle: ButtonStyle = 'default';
    export let buttonSize: ComponentSize = 'md';
    export let isBlock = false;
    export let isDisabled = false;
    export let title = '';
    export let additionalClasses = '';
    export let id: string = null;

    const definedActionPerformer = getInjector().getByClass(DefinedActionPerformer);

    const dispatch = createEventDispatcher<{'post-action': any}>();

    async function performAction() {
        const actionReturnedValue = await definedActionPerformer.performAction(action);
        dispatch('post-action', actionReturnedValue);
    }
</script>

<KpButton {id}
          {buttonStyle}
          {buttonSize}
          {isDisabled}
          {title}
          {isBlock}
          additionalClasses="kp-defined-action-button {additionalClasses}"
          {...$$restProps}
          on:click={performAction}>

    <slot/>
</KpButton>